var _defs, _polygon, _polygon2, _g, _g2, _circle, _circle2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAyurvedic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .e {\n        fill: #ecb021;\n      }\n\n      .e, .f, .g, .h, .i, .j, .k, .l, .m, .n, .o, .p, .q, .r, .s {\n        stroke-width: 0px;\n      }\n\n      .t {\n        fill: none;\n        stroke: #6ebe44;\n        stroke-width: .75px;\n      }\n\n      .t, .u {\n        stroke-miterlimit: 10;\n      }\n\n      .v {\n        opacity: .5;\n      }\n\n      .f {\n        fill: #b01f8d;\n      }\n\n      .g {\n        fill: #e4e3ff;\n      }\n\n      .h {\n        fill: #994f1d;\n      }\n\n      .u {\n        fill: url(#b);\n        stroke: url(#c);\n        stroke-width: .5px;\n      }\n\n      .i {\n        fill: #aa5821;\n      }\n\n      .j {\n        fill: #f9b938;\n      }\n\n      .k {\n        fill: #fff;\n      }\n\n      .l {\n        fill: #193319;\n      }\n\n      .m {\n        fill: #b75f25;\n      }\n\n      .n {\n        fill: #5bc658;\n      }\n\n      .o {\n        fill: #49a247;\n      }\n\n      .w {\n        opacity: .3;\n      }\n\n      .p {\n        fill: #de5ca2;\n      }\n\n      .q {\n        fill: #3c9b3a;\n      }\n\n      .r {\n        fill: #529e26;\n      }\n\n      .s {\n        fill: #d0d0f7;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 6.2,
    y1: 0.13,
    x2: 42.52,
    y2: 45.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5bc658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#3c853a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#143214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.74,
    y1: 30,
    x2: 59.26,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#143214"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#3c853a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5bc658"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "r",
    points: "56.56 42.23 53.62 45.49 51.77 49.48 48 51.73 45.06 54.99 40.79 56.03 37.02 58.28 32.64 58.01 28.37 59.05 24.26 57.5 19.88 57.24 16.41 54.55 12.29 53.01 9.77 49.41 6.3 46.72 4.94 42.55 2.42 38.95 2.35 34.56 1 30.39 2.23 26.17 2.17 21.78 4.59 18.12 5.83 13.9 9.22 11.12 11.64 7.45 15.71 5.79 19.1 3 23.47 2.61 27.54 .95 31.83 1.87 36.21 1.47 40.04 3.62 44.34 4.53 47.37 7.71 51.2 9.85 53.16 13.78 56.2 16.95 56.91 21.29 58.88 25.21 58.28 29.57 59 33.9 57.15 37.88 56.56 42.23"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "u",
    points: "56.56 42.23 53.62 45.49 51.77 49.48 48 51.73 45.06 54.99 40.79 56.03 37.02 58.28 32.64 58.01 28.37 59.05 24.26 57.5 19.88 57.24 16.41 54.55 12.29 53.01 9.77 49.41 6.3 46.72 4.94 42.55 2.42 38.95 2.35 34.56 1 30.39 2.23 26.17 2.17 21.78 4.59 18.12 5.83 13.9 9.22 11.12 11.64 7.45 15.71 5.79 19.1 3 23.47 2.61 27.54 .95 31.83 1.87 36.21 1.47 40.04 3.62 44.34 4.53 47.37 7.71 51.2 9.85 53.16 13.78 56.2 16.95 56.91 21.29 58.88 25.21 58.28 29.57 59 33.9 57.15 37.88 56.56 42.23"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m5.53,26.21l-.89-.18.34-1.71,5.26,1.04-.2,1.03-4.37-.86-.14.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m9.74,19.02c1.05.46,2.37,1.58,1.8,2.88-.57,1.3-2.3,1.08-3.34.62-1.05-.46-2.39-1.58-1.82-2.89.58-1.31,2.3-1.08,3.36-.62Zm-1.14,2.57c.49.21,1.82.63,2.12-.05.3-.68-.91-1.38-1.4-1.59-.49-.22-1.8-.63-2.1.05-.3.68.89,1.37,1.38,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m12.59,14.9c.92.68,1.98,2.06,1.14,3.21-.84,1.15-2.48.56-3.4-.11-.93-.68-2-2.06-1.15-3.22.85-1.16,2.49-.56,3.42.12Zm-1.67,2.26c.43.31,1.64,1.01,2.08.41.44-.6-.59-1.54-1.02-1.86-.44-.32-1.62-1-2.07-.4-.44.6.57,1.53,1.01,1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m14.25,11.2c.47.56.39,1.32-.17,1.79s-1.32.4-1.79-.16c-.47-.57-.39-1.33.17-1.79.56-.46,1.32-.4,1.79.17Zm-1.42,1.17c.21.25.6.4.88.17.27-.23.21-.64,0-.89-.21-.25-.61-.4-.88-.17-.27.23-.2.65,0,.9Zm2.15-3.17l1.31,6.09-.54.12-1.3-6.09.53-.12Zm3.46,2.56c.47.56.39,1.32-.17,1.79-.56.47-1.32.4-1.79-.16-.47-.57-.39-1.33.17-1.79.56-.46,1.32-.4,1.79.17Zm-1.42,1.17c.21.25.6.4.88.17.27-.23.21-.64,0-.89-.21-.25-.61-.4-.88-.17-.27.23-.2.65,0,.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m22.72,9.83l-.08,1.21-1.05.33.35-5.87.77-.24,3.58,4.64-1.06.33-.73-.95-1.77.56Zm.02-2.94h-.01s.02,2.04.02,2.04l1.21-.38-1.22-1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m25.24,4.7l1.21-.12,1.12,1.76.83-1.95,1.21-.12-1.39,3.05.24,2.44-1.04.1-.24-2.44-1.94-2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m31.37,4.31l1.04.13-.39,2.97c-.08.66-.15,1.59.73,1.7.88.11,1.06-.8,1.14-1.46l.39-2.97,1.04.13-.41,3.18c-.17,1.3-.85,2.21-2.27,2.02-1.42-.19-1.85-1.24-1.68-2.53l.41-3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m39.02,11.7l-1.18-.44-.46-2.48h-.01s-.76,2.02-.76,2.02l-.98-.37,1.88-5.02,1.32.5c.99.37,1.51,1.07,1.11,2.14-.24.64-.83,1.15-1.54,1.01l.63,2.64Zm-1.4-3.61l.13.05c.54.2.98.18,1.21-.43.23-.62-.12-.89-.64-1.08l-.13-.05-.56,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m42.16,11.62h.01s2.98-2.34,2.98-2.34l.94.62-4.76,3.44-.51-.34,1.32-5.71.94.62-.91,3.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m47.46,12.47l-.84.83,1.16,1.18-.65.64-1.16-1.18-1.03,1.01,1.21,1.23-.65.64-1.94-1.98,3.82-3.75,1.94,1.98-.65.64-1.21-1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m50.69,14.72l.79,1.26c.83,1.31.4,2.8-.9,3.62-1.27.8-2.83.52-3.64-.77l-.79-1.26,4.53-2.85Zm-3.21,3.25l.09.14c.68,1.09,1.55,1.13,2.45.57.99-.62,1.18-1.45.55-2.45l-.09-.14-2.99,1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m49,22.84l-.39-.97,4.96-2.01.39.97-4.96,2.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m54.04,26.54c.28-.36.4-.84.3-1.27-.21-.98-1.24-1.34-2.14-1.14-.88.19-1.63.97-1.42,1.92.1.44.42.82.81,1.04l-1.21.27c-.26-.34-.48-.69-.57-1.12-.32-1.47.7-2.84,2.15-3.15,1.48-.33,3.02.43,3.36,1.96.09.41.07.83-.05,1.23l-1.22.27Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m9.68,36.92l.3.66-2.12,3.96h0s3.13-1.43,3.13-1.43l.42.91-4.75,2.19-.3-.65,2.12-3.96h0s-3.16,1.45-3.16,1.45l-.42-.91,4.78-2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m9.16,46.76c-.98-1.22-.66-2.73.51-3.67,1.19-.96,2.73-.91,3.69.28.96,1.19.68,2.71-.5,3.67-1.18.95-2.72.94-3.7-.28Zm3.44-2.77c-.59-.74-1.6-.64-2.24-.12-.61.5-1.12,1.41-.43,2.28s1.7.56,2.32.06c.65-.52.95-1.48.35-2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m18.53,49.52c-.02-.32-.14-.59-.42-.77-.27-.17-.66-.14-.84.14-.47.72,1.43,1.53.49,2.97-.56.86-1.49,1.12-2.37.55-.59-.39-.8-1.01-.78-1.7l.89-.18c-.1.41,0,.9.37,1.13.34.22.74.07.96-.26.29-.45-.04-.84-.29-1.19-.41-.59-.63-1.13-.19-1.8.46-.71,1.37-.95,2.09-.47.38.25.79.78.86,1.24l-.77.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m19.13,54.31l-.9-.43,2.19-4.64.9.43-2.19,4.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m22.17,50.09l1.37.4c1.42.42,2.06,1.76,1.65,3.17-.41,1.38-1.7,2.17-3.11,1.75l-1.37-.4,1.45-4.92Zm-.24,4.37l.16.05c1.18.35,1.83-.17,2.12-1.14.32-1.07-.07-1.79-1.16-2.11l-.16-.05-.96,3.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m27.49,52.21l-.11,1.12,1.58.16-.09.87-1.58-.16-.14,1.38,1.65.16-.09.87-2.64-.26.51-5.11,2.64.26-.09.87-1.65-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m33.53,52.08l.19,1.11,1.57-.27.15.86-1.57.27.24,1.37,1.63-.28.15.86-2.61.45-.87-5.05,2.61-.45.15.86-1.63.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m37.09,51.21l.37,1.07,1.37-.47.28.82-1.37.47.73,2.14-.95.33-1.67-4.86,2.41-.83.28.82-1.46.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m40.3,49.84l.53,1,1.28-.68.41.77-1.28.68,1.06,2-.88.47-2.42-4.53,2.25-1.2.41.77-1.37.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m43.27,47.99l.68.9,1.27-.96.53.69-1.27.96.84,1.11,1.32-1,.53.69-2.11,1.61-3.11-4.08,2.11-1.61.53.69-1.32,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m48.02,44.14c-.44-.02-.87.15-1.16.47-.65.71-.37,1.71.29,2.31.64.58,1.66.75,2.29.06.29-.32.41-.78.37-1.21l.88.8c-.12.4-.28.76-.56,1.07-.97,1.06-2.61,1.01-3.66.06-1.07-.98-1.33-2.61-.31-3.72.27-.3.62-.51.99-.64l.88.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m52.73,43.87l-.54.84-3.59-2.29-.56.87-.73-.47,1.65-2.59.73.47-.56.87,3.59,2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m51.2,37.95c-.31.07-.56.24-.69.54-.12.29-.02.67.29.8.79.34,1.26-1.67,2.84-1,.94.4,1.36,1.28.95,2.24-.28.65-.86.97-1.54,1.06l-.33-.84c.42.03.88-.16,1.05-.56.16-.38-.06-.74-.42-.9-.49-.21-.82.18-1.12.49-.51.5-1.01.81-1.74.5-.78-.33-1.17-1.18-.83-1.98.18-.42.63-.91,1.08-1.06l.45.7Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "l",
    cx: 30,
    cy: 30,
    r: 18.73
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "t",
    cx: 30,
    cy: 30,
    r: 16.94
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "d",
    "data-name": 100
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m39.17,23.94l-1.69,2.17-2.6,3.35-.71.91-1.01-.91-3.06-2.78.6-.57,5.31-5.04,3.16,2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m38.78,24.45h0c-1.54-1.39-3.89-1.37-5.39.06l-2.78,2.64-.51-.46,5.91-5.61,3.16,2.86-.39.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m40.44,23.91c-.33.36-.9.4-1.27.06l-3.19-2.89c-.37-.33-.4-.9-.06-1.27.17-.18.39-.28.62-.29.23-.01.46.06.65.23l3.19,2.89c.37.33.4.9.06,1.27Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m37.48,26.11l-2.6,3.35h-1.72l-3.06-2.78.6-.57h6.78Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m23.16,28.03c.03.16-.11.29-.26.26-.07-.01-.14-.03-.23-.04,0,0,0,0-.01,0-.08-.02-.17-.04-.26-.06-.64-.17-1.54-.51-2.3-1.17-.08-.07-.15-.14-.23-.22-.21-.21-.39-.44-.54-.68-.6-.9-.83-1.89-.92-2.37,0-.05,0-.1.02-.15,0-.01.02-.03.03-.05.04-.04.14-.08.2-.06.93.19,1.85.52,2.64,1.14.47.38.87.83,1.22,1.49.35.66.53,1.29.64,1.92Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "w"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m20.16,26.64s-.11.04-.15,0c-.7-.71-1.06-1.61-1.25-2.25-.02-.06.02-.11.07-.13.06-.02.11.02.13.07.18.61.52,1.48,1.19,2.16.04.04.04.11,0,.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "m23.16,28.03c.03.16-.11.29-.26.26-.07-.01-.15-.02-.23-.04,0,0,0,0-.01,0-.08-.02-.17-.04-.26-.06.02-.04.03-.09.02-.15-.07-.41-.24-1.16-.64-1.92-.21-.39-.47-.79-.82-1.14-.79-.8-1.82-1.2-2.52-1.38,0-.01.02-.03.03-.05.04-.04.14-.08.2-.06.92.19,1.84.52,2.64,1.14.47.38.87.83,1.22,1.49.32.61.52,1.24.64,1.92Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "m30.21,23.81c-.06.48-.42,1.57-.82,2.18-.02.04-.05.08-.08.12-.13.19-.26.37-.42.55-.06.06-.11.12-.17.18h0c-1.03,1.02-2.44,1.36-3.05,1.46-.04,0-.09,0-.13-.01-.02,0-.05-.02-.07-.05-.05-.05-.07-.12-.06-.2,0-.04.01-.09.03-.14.02-.11.05-.24.08-.38.08-.3.2-.65.37-1.02.06-.13.12-.26.2-.39.21-.38.48-.76.82-1.1,1.03-1.02,2.44-1.36,3.05-1.47.05,0,.1,0,.14.03.09.05.13.16.11.24Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "w"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m27.05,25.31s-.04-.11,0-.15c.71-.7,1.61-1.06,2.25-1.25.06-.02.11.02.13.07.02.06-.02.11-.07.13-.61.18-1.48.52-2.16,1.19-.04.04-.11.04-.15,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m30.22,23.81c-.05.39-.39,1.52-.83,2.18-.02.04-.05.08-.08.12-.13.19-.26.37-.42.55-.84.91-2.02,1.44-3.23,1.64-.04,0-.09,0-.13-.01-.02,0-.05-.02-.07-.05-.05-.05-.07-.12-.06-.2,0-.04.01-.09.03-.14.02-.11.05-.24.08-.38.04.02.1.04.15.03.6-.1,2-.44,3.03-1.45,0,0,.01-.01.02-.02.8-.79,1.2-1.82,1.38-2.52.09.04.13.15.12.24Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m25.95,24.02c0,.57-.11,1.3-.39,2.09-.05.15-.11.28-.17.42-.2.46-.41.86-.61,1.17-.05.08-.1.17-.15.24s-.09.14-.13.19c-.12.17-.36.16-.48,0-.07-.11-.16-.25-.26-.41-.03-.05-.07-.11-.1-.17-.23-.39-.47-.88-.67-1.45-.24-.7-.37-1.38-.37-2.11.01-1.87.99-3.46,1.45-4.11.04-.06.09-.1.16-.11.08-.04.23,0,.31.11.81,1.14,1.4,2.66,1.4,4.13Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "w"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m23.04,24.14c-.08,0-.14-.06-.13-.14,0-1.28.5-2.43.91-3.18.04-.07.12-.09.18-.05.07.04.09.12.05.18-.4.72-.87,1.82-.88,3.05,0,.08-.06.14-.14.13Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m25.95,24.02c0,.66-.17,1.5-.39,2.09-.05.15-.1.29-.16.42-.2.46-.41.86-.61,1.17-.05.08-.1.17-.15.24s-.09.14-.13.19c-.12.17-.36.16-.48,0-.07-.11-.16-.25-.26-.41-.03-.05-.07-.11-.1-.17h0c.06-.01.11-.05.16-.11.2-.28.5-.75.77-1.34.35-.76.67-1.73.67-2.78,0-1.45-.57-2.74-1.03-3.55.1-.03.23,0,.31.11.82,1.27,1.4,2.57,1.4,4.13Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m18.02,28.55c.06,4.2,2,7.89,4.92,10.04h11.85c2.92-2.15,4.86-5.83,4.92-10.04h-21.69Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "w"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m20.77,35.54c-.77-1.12-1.35-2.37-1.72-3.72-.06-.22.07-.45.29-.51.22-.06.45.07.51.29.35,1.26.89,2.43,1.6,3.46.13.19.08.45-.11.58-.19.13-.45.08-.58-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m22.02,37.05c-.2-.2-.39-.41-.58-.63-.15-.18-.13-.44.05-.59.18-.15.44-.13.59.05.17.2.35.4.54.59.16.16.16.43,0,.59-.16.16-.43.16-.59,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m39.71,28.55c-.06,4.21-2,7.89-4.92,10.04h-11.85c-.61-.45-1.19-.98-1.7-1.55.26.25.53.47.81.67h6.72c5.16,0,9.55-3.9,9.99-9.04,0-.04,0-.08,0-.11h.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m35.72,39.47c0,.57-.46,1.02-1.02,1.02h-11.66c-.57,0-1.02-.45-1.02-1.02s.45-1.02,1.02-1.02h11.66c.56,0,1.02.46,1.02,1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m35.72,39.47c0,.56-.46,1.02-1.02,1.02h-11.66c-.45,0-.83-.29-.97-.69.1.03.22.05.33.05h11.66c.56,0,1.02-.45,1.02-1.02,0-.11-.02-.22-.05-.32.4.14.69.52.69.96h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "m23.16,28.03c.03.16-.11.29-.26.26-.07-.01-.15-.02-.23-.04,0,0,0,0-.01,0-.08-.02-.17-.04-.26-.06-.64-.17-1.54-.51-2.3-1.17-.08-.07-.15-.14-.23-.22-.21-.21-.39-.44-.54-.68h3.2c.35.66.53,1.29.64,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m25.4,26.54c-.2.46-.41.86-.61,1.17-.05.08-.1.17-.15.24s-.09.14-.13.19c-.12.17-.36.16-.48,0-.07-.11-.16-.25-.26-.41-.03-.05-.07-.11-.1-.17h0c-.23-.39-.47-.88-.67-1.45h2.56c-.05.15-.11.28-.17.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m29.31,26.11c-.13.19-.26.37-.42.55-.06.06-.11.12-.17.18h0c-1.03,1.02-2.44,1.36-3.05,1.46-.04,0-.09,0-.13-.01-.02,0-.05-.02-.07-.05-.05-.05-.07-.12-.06-.2,0-.04.01-.09.03-.14.02-.11.05-.24.08-.38.08-.3.2-.65.37-1.02.06-.13.12-.26.2-.39h3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m40.6,27.79c0,.66-.54,1.19-1.19,1.19h-21.1c-.66,0-1.19-.53-1.19-1.19s.53-1.19,1.19-1.19h21.1c.65,0,1.19.54,1.19,1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "m40.6,27.79c0,.66-.53,1.19-1.19,1.19h-21.1c-.57,0-1.04-.4-1.15-.93.08.02.17.03.25.03h21.1c.65,0,1.19-.53,1.19-1.19,0-.09,0-.17-.03-.25.53.12.93.59.93,1.16Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "v"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m19.99,27.35c0-.16.14-.3.3-.3h4.92c.17,0,.3.14.3.3s-.13.3-.3.3h-4.92c-.14,0-.3-.12-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m18.76,27.35c0-.16.14-.3.3-.3h.45c.16,0,.3.14.3.3s-.14.3-.3.3h-.45c-.14,0-.3-.12-.3-.3Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "w"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m37.22,20.49c.06-.07.17-.07.24-.01l2.04,1.85c.07.06.07.17.01.24-.06.07-.17.08-.24.01l-2.04-1.85c-.06-.05-.08-.16-.01-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m36.63,19.94c.06-.07.17-.07.24-.01l.19.17c.07.06.07.17.01.24-.06.07-.17.07-.24.01l-.19-.17c-.06-.05-.08-.16-.01-.24Z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m8.94,32.55c-.16.32-.42.71-.79,1.08-.07.07-.14.13-.21.19-.24.21-.47.37-.66.5-.05.03-.1.07-.15.09s-.09.05-.13.07c-.11.06-.25,0-.27-.13-.01-.08-.02-.18-.04-.3,0-.04,0-.08-.01-.12-.02-.28-.03-.63.02-1,.06-.46.16-.88.37-1.3.52-1.06,1.51-1.7,1.95-1.94.04-.02.08-.03.12-.02.06,0,.13.06.15.15.15.87.07,1.89-.34,2.73Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "w"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m7.26,31.82s-.06-.07-.04-.11c.35-.73.95-1.25,1.39-1.56.04-.03.09-.02.12.02.03.04.02.09-.02.12-.42.3-.99.8-1.33,1.49-.02.04-.07.06-.11.04Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m8.94,32.55c-.18.38-.5.8-.79,1.08-.07.07-.14.14-.21.2-.24.21-.47.37-.66.5-.05.03-.1.07-.15.09s-.09.05-.13.07c-.11.06-.25,0-.27-.13-.01-.08-.02-.18-.04-.3,0-.04,0-.08-.01-.12h0s.08,0,.12-.02c.19-.11.49-.29.81-.55.41-.34.85-.8,1.14-1.39.4-.82.43-1.71.38-2.3.06,0,.13.06.15.15.12.94.09,1.84-.34,2.73Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m6.05,31.67c.16.32.29.77.35,1.29,0,.1.02.19.02.29.01.32,0,.6-.03.83,0,.06-.01.12-.02.18s-.02.1-.02.14c-.02.13-.16.19-.27.13-.07-.04-.16-.1-.26-.16-.03-.02-.07-.05-.1-.07-.23-.16-.51-.37-.77-.64-.33-.33-.59-.68-.79-1.1-.5-1.07-.39-2.24-.3-2.73,0-.04.03-.08.06-.1.04-.04.13-.07.21-.02.77.43,1.52,1.13,1.92,1.96Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "w"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m4.43,32.54s-.09,0-.11-.04c-.35-.73-.38-1.52-.35-2.05,0-.05.04-.08.09-.08.05,0,.08.04.08.09-.03.51,0,1.27.34,1.97.02.04,0,.09-.04.11Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m6.05,31.67c.18.38.31.9.35,1.29.01.1.02.19.02.28.01.32,0,.6-.03.83,0,.06-.01.12-.02.18s-.02.1-.02.14c-.02.13-.16.19-.27.13-.07-.04-.16-.1-.26-.16-.03-.02-.07-.04-.1-.07h0s.05-.06.06-.11c.04-.22.08-.56.07-.97,0-.53-.09-1.16-.38-1.76-.39-.82-1.07-1.4-1.56-1.73.05-.04.13-.06.21-.02.81.5,1.5,1.08,1.92,1.96Z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m55.45,32.55c-.16.32-.42.71-.79,1.08-.07.07-.14.13-.21.19-.24.21-.47.37-.66.5-.05.03-.1.07-.15.09s-.09.05-.13.07c-.11.06-.25,0-.27-.13-.01-.08-.02-.18-.04-.3,0-.04,0-.08-.01-.12-.02-.28-.03-.63.02-1,.06-.46.16-.88.37-1.3.52-1.06,1.51-1.7,1.95-1.94.04-.02.08-.03.12-.02.06,0,.13.06.15.15.15.87.07,1.89-.34,2.73Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "w"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m53.76,31.82s-.06-.07-.04-.11c.35-.73.95-1.25,1.39-1.56.04-.03.09-.02.12.02.03.04.02.09-.02.12-.42.3-.99.8-1.33,1.49-.02.04-.07.06-.11.04Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m55.45,32.55c-.18.38-.5.8-.79,1.08-.07.07-.14.14-.21.2-.24.21-.47.37-.66.5-.05.03-.1.07-.15.09s-.09.05-.13.07c-.11.06-.25,0-.27-.13-.01-.08-.02-.18-.04-.3,0-.04,0-.08-.01-.12h0s.08,0,.12-.02c.19-.11.49-.29.81-.55.41-.34.85-.8,1.14-1.39.4-.82.43-1.71.38-2.3.06,0,.13.06.15.15.12.94.09,1.84-.34,2.73Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m52.56,31.67c.16.32.29.77.35,1.29,0,.1.02.19.02.29.01.32,0,.6-.03.83,0,.06-.01.12-.02.18s-.02.1-.02.14c-.02.13-.16.19-.27.13-.07-.04-.16-.1-.26-.16-.03-.02-.07-.05-.1-.07-.23-.16-.51-.37-.77-.64-.33-.33-.59-.68-.79-1.1-.5-1.07-.39-2.24-.3-2.73,0-.04.03-.08.06-.1.04-.04.13-.07.21-.02.77.43,1.52,1.13,1.92,1.96Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "w"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m50.94,32.54s-.09,0-.11-.04c-.35-.73-.38-1.52-.35-2.05,0-.05.04-.08.09-.08.05,0,.08.04.08.09-.03.51,0,1.27.34,1.97.02.04,0,.09-.04.11Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m52.56,31.67c.18.38.31.9.35,1.29.01.1.02.19.02.28.01.32,0,.6-.03.83,0,.06-.01.12-.02.18s-.02.1-.02.14c-.02.13-.16.19-.27.13-.07-.04-.16-.1-.26-.16-.03-.02-.07-.04-.1-.07h0s.05-.06.06-.11c.04-.22.08-.56.07-.97,0-.53-.09-1.16-.38-1.76-.39-.82-1.07-1.4-1.56-1.73.05-.04.13-.06.21-.02.81.5,1.5,1.08,1.92,1.96Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAyurvedic);
export default __webpack_public_path__ + "static/media/ayurvedic.428c2533d519b9686f3c21b6528ac558.svg";
export { ForwardRef as ReactComponent };